import { CommonBaseWidgetSchema } from '@framework/engine/schema/widgets/CommonBaseWidgetSchema.ts';
import { type IWidgetComponentProps } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { type ISectionWidget, WidgetSectionType } from './ISectionWidget.ts';

export const SectionWidgetConfigSchema: yup.ObjectSchema<ISectionWidget> =
  CommonBaseWidgetSchema.shape({
    type: yup.string().exact(WidgetSectionType).required(),
    name: yup.string().nullable().optional().default('').label('Nome Sezione'),
    placeholder: yup
      .string()
      .nullable()
      .optional()
      .default('')
      .label('Placeholder Sezione'),
  });

interface ISectionWidgetConfigComponentProps
  extends IWidgetComponentProps<ISectionWidget> {}

export function SectionWidgetConfigComponent(
  props: ISectionWidgetConfigComponentProps,
) {
  return (
    <div>
      <FormItem name="name" label="Nome Sezione">
        <TextInput name="name" />
      </FormItem>
      <FormItem name="placeholder" label="Placeholder Sezione">
        <TextInput name="placeholder" />
      </FormItem>
    </div>
  );
}
